export default "__VITE_ASSET__CLMr$Mi2__ 54w";